import { render, staticRenderFns } from "./FortalHair.vue?vue&type=template&id=4528fe12&scoped=true"
import script from "./FortalHair.vue?vue&type=script&lang=js"
export * from "./FortalHair.vue?vue&type=script&lang=js"
import style0 from "./FortalHair.vue?vue&type=style&index=0&id=4528fe12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528fe12",
  null
  
)

export default component.exports